import { SoldDataShareFormControlName } from '../enums';

export const SOLD_DATA_SHARE_FORM_DEFAULT_VALUE = {
  [SoldDataShareFormControlName.Name]: '',
  [SoldDataShareFormControlName.Email]: '',
};

export default {
  SOLD_DATA_SHARE_FORM_DEFAULT_VALUE,
};
